<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/currencyconfig" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("system.label.Edit") + currency.type }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <vx-card>
        <div class="vx-row" v-show="false">
          <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/6 xl:w-1/6">
            <input
              id="Currency"
              type="radio"
              value="Currency"
              v-model="currency.type"
            />
            <label for="Currency"> {{ $t("system.label.currency") }} </label>
          </div>
          <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/6 xl:w-1/6">
            <input
              id="Non-Currency"
              type="radio"
              value="Non-Currency"
              v-model="currency.type"
            />
            <label for="Non-Currency">
              {{ $t("system.label.nonCurrency") }}
            </label>
          </div>
        </div>
        <div class="vx-row mt-3">
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required|max:3"
              v-slot="{ errors }"
              :name="$t('system.label.code')"
            >
              <vs-input
                :label="$t('system.label.code')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="currency.code"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('system.label.decimalPlaces')"
            >
              <vs-input
                :label="$t('system.label.decimalPlaces')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="currency.decimalPlaces"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('system.label.name')"
            >
              <vs-input
                :label="$t('system.label.name')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="currency.name"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("customers.label.status")
                }}<span class="required">*</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('customers.label.status')"
              >
                <v-select
                  v-model="currency.status"
                  :options="statusOptions"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              v-if="currency.type == 'Currency'"
              :name="$t('system.label.displaySymbol')"
            >
              <vs-input
                :label="$t('system.label.displaySymbol')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="currency.displaySymbol"
                v-if="currency.type == 'Currency'"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              v-if="currency.type == 'Currency'"
              :name="$t('system.label.internationalNameCode')"
            >
              <vs-input
                :label="$t('system.label.internationalNameCode')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="currency.nameCode"
                v-if="currency.type == 'Currency'"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              v-if="currency.type == 'Currency'"
              :name="$t('system.label.countryCode')"
            >
              <vs-input
                :label="$t('system.label.countryCode')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="currency.countryCode"
                v-if="currency.type == 'Currency'"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              v-if="currency.type == 'Currency'"
              :name="$t('system.label.countryName')"
            >
              <vs-input
                :label="$t('system.label.countryName')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="currency.countryName"
                v-if="currency.type == 'Currency'"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
        </div>
      </vx-card>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("system.label.cancel") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="validateForm"
            >{{ $t("system.label.submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <div class="centerx">
      <vs-popup
        class="warning-msg popup-close"
        classContent="popup-example"
        :title="null"
        :active.sync="warningPopup"
      >
        <div
          style="font-size: 20px; color: rgb(255, 204, 0); margin-left: 10px"
          v-if="warningText"
        >
          ⚠ Warning!!
        </div>
        <div
          style="font-size: 20px; color: orangered; margin-left: 10px"
          v-if="errorMessage"
        >
          ⛔ Error!!
        </div>

        <div class="font-semibold p-3">
          {{ warningText }}
          {{ errorMessage }}
        </div>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const currencyEmptyObj = {
  type: "Currency",
  code: "",
  nameCode: "",
  decimalPlaces: "",
  countryCode: "",
  countryName: "",
  name: "",
  displaySymbol: "",
  locale: "en",
  status: "",
};

export default {
  data() {
    return {
      currency: currencyEmptyObj,
      warningPopup: false,
      warningText: "",
      errors: [],
      statusOptions: ["ACTIVE", "INACTIVE"],
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      postResponse: (state) => state.currencyMaster.updateCurrency,
      currencyByIdObj: (state) => state.currencyMaster.currencyById,
      errorMessage: (state) => state.currencyMaster.formError,
    }),
    breadcrumbs() {
      // let a = this.currency.type;
      return [
        {
          name: this.$t("reports.label.currencyMaster"),
          to: "/currencyconfig",
        },
        { name: this.$t("Edit ") + this.currency.type, to: "/" },
      ];
    },
  },
  methods: {
    async getCurrencies() {
      try {
        await this.$store.dispatch("currencyMaster/setCurrencyById", this.id);
        this.currency = { ...this.currencyByIdObj };
      } catch (error) {
        console.error("Error fetching currency data:", error);
        // Handle error appropriately
      }
    },

    async validateForm() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      this.editCurrency();
    },

    async editCurrency() {
      this.currency = {
        code: this.currency.code,
        type: this.currency.type,
        decimalPlaces: this.currency.decimalPlaces,
        name: this.currency.name,
        displaySymbol: this.currency.displaySymbol,
        nameCode: this.currency.nameCode,
        countryName: this.currency.countryName,
        countryCode: this.currency.countryCode,
        status: this.currency.status,
        locale: "en",
      };
      const payload = {
        id: this.id,
        currency: this.currency,
      };

      await this.$store.dispatch("currencyMaster/setPutCurrency", payload);
      this.$swal({
        title: "Success",
        icon: "success",
        text:
          this.currency.type == "Currency"
            ? "Currency Edited Successfully!"
            : "Non-Currency Edited Successfully!",
        type: "success",
      });

      if (this.postResponse) {
        this.$router.push(`/currencyconfig`);
      }
      if (this.errorMessage) {
        this.warningPopup = true;
      }
    },
    resetForm() {
      this.currency = currencyEmptyObj;
    },
    cancel() {
      this.$router.push("/currencyconfig");
    },
  },
  watch: {},
  mounted() {
    this.id = this.$route.params.id;
    const breadcrumb = document.querySelector(".breadcrumb");

    if (breadcrumb) {
      const lastChild = breadcrumb.lastElementChild;

      if (lastChild) {
        lastChild.textContent = `Edit ${this.currency.type}`;
      }
    }
    this.getCurrencies();
  },
};
</script>
<style></style>
